import React from 'react';
import ReactMarkdown from 'react-markdown';
import { TableBody, TableHead, TableRow } from 'react-magma-dom';
import { LessonHeading } from '../LessonHeading';
import { LessonText } from '../LessonText';
import { StyledTableRow, StyledTableHeaderCell, StyledTableCell, StyledTable } from '../../Styled';
import { LessonPageHeading, LessonPageTable, LessonPageTableStyles, LessonPageText } from '../../../types/lessons';
import { CONTENT_TYPES } from '../../../constants/lessons';
import { COLORS } from '../../../constants';

interface ILessonPageTable extends LessonPageTable {
  linkColor?: string;
}

export const LessonTable: React.FC<ILessonPageTable> = props => {
  const { rows, text, style, linkColor } = props;

  const isTowardsAtBeyond = style?.includes(LessonPageTableStyles.towardsAtBeyond);

  return (
    <StyledTable isTowardsAtBeyond={isTowardsAtBeyond}>
      {text && (
        <TableHead>
          <StyledTableRow>
            <StyledTableHeaderCell colSpan={rows[0].content.length}>
              <ReactMarkdown skipHtml={false}>{text}</ReactMarkdown>
            </StyledTableHeaderCell>
          </StyledTableRow>
        </TableHead>
      )}
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={`row-${index}`}>
            {row.content.map((cell, cellIndex) => (
              <StyledTableCell width={100 / row.content.length} key={`cell-${index}-${cellIndex}`}>
                {cell.type === CONTENT_TYPES.heading && (
                  <LessonHeading
                    isTooltipShown
                    fontSize={20}
                    color={isTowardsAtBeyond ? COLORS.black : COLORS.blackOlive}
                    {...(cell as LessonPageHeading)}
                  />
                )}
                {cell.type === CONTENT_TYPES.text && (
                  <LessonText
                    isTooltipShown
                    withCustomIcon
                    color={isTowardsAtBeyond ? COLORS.black : COLORS.blackOlive}
                    linkColor={linkColor}
                    {...(cell as LessonPageText)}
                  />
                )}
              </StyledTableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};
